module.exports = __webpack_public_path__ + "static/media/tire_selected.f4d5fc10.svg";